/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_Archive_Reason_FireInputs */

const fr_vehicle_details_archive_reason_fire = /** @type {(inputs: Vehicle_Details_Archive_Reason_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a été victime d'un incendie`)
};

const en_vehicle_details_archive_reason_fire = /** @type {(inputs: Vehicle_Details_Archive_Reason_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`was damaged by fire`)
};

/**
* | output |
* | --- |
* | "was damaged by fire" |
*
* @param {Vehicle_Details_Archive_Reason_FireInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_archive_reason_fire = /** @type {((inputs?: Vehicle_Details_Archive_Reason_FireInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Archive_Reason_FireInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_archive_reason_fire(inputs)
	return en_vehicle_details_archive_reason_fire(inputs)
});